module.exports = __webpack_public_path__ + "assets/img/nx-02.21ac2466.jpg";